// extracted by mini-css-extract-plugin
export default {"drawer":"SideBar_drawer__SZiGX","drawerPaper":"SideBar_drawerPaper__5JJv8","drawerContainer":"SideBar_drawerContainer__8zPG5","link":"SideBar_link__RTVj3"};